import { Error } from "@mui/icons-material";
import { Tooltip, TextField, useTheme, Stack } from "@mui/material";
import { useGridApiContext } from "@mui/x-data-grid";
import { useEffect, useState, useRef } from "react";

export default function EditcellTextField({
  id,
  field,
  value: initialValue,
  error,
  setIsEdit = () => {},
  selected,
}) {
  const apiRef = useGridApiContext();
  const theme = useTheme();
  const [inputValue, setInputValue] = useState(initialValue);
  const inputRef = useRef(null);

  useEffect(() => {
    setInputValue(initialValue);
  }, [initialValue]);

  const handleChange = (event) => {
    const newValue = event.target.value;
    setInputValue(newValue); // Atualiza o estado local primeiro

    setIsEdit((data) => (data.includes(id) ? data : [...data, id]));

    apiRef.current.setEditCellValue({
      id,
      field,
      value: newValue,
      debounceMs: 1,
    });
  };

  return (
    <Tooltip
      title={error}
      placement="bottom-start"
      slotProps={{
        tooltip: {
          sx: {
            p: 0.5,
            px: 1,
            bgcolor: theme.palette.mode === "dark" ? "#F44336" : "#D32F2F",
            color: "#fff",
            fontSize: 14,
            borderRadius: "3px",
          },
        },
        popper: {
          sx: { pointerEvents: "none" },
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, -5],
              },
            },
          ],
        },
      }}
    >
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        sx={{
          height: "100%",
          width: "100%",
          border: selected ? `1px solid ${theme.palette.primary.main}` : null,
        }}
      >
        <TextField
          key={id + "_textField"}
          autoFocus
          autoComplete="off"
          onChange={handleChange}
          variant="standard"
          sx={{
            p: "0px 10px",
            width: "100%",

            "& .MuiInputBase-root": {
              backgroundColor: "transparent", // Remove fundo ao focar
            },
            "& .MuiInputBase-root.Mui-focused": {
              backgroundColor: "transparent", // Mantém transparente ao focar
            },
          }}
          value={inputValue}
          inputRef={inputRef}
          slotProps={{
            input: {
              disableUnderline: true,
              style: { fontSize: "13px" },
              endAdornment: error === "Campo obrigatório" && (
                <Error color="error" sx={{ fontSize: "18px" }} />
              ),
            },
          }}
          error={!!error}
        />
      </Stack>
    </Tooltip>
  );
}
